import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Upsell: when a business hits a feature outside its plan (403), nudge to upgrade.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof d === "string" && /plan|suscrip/i.test(d)) {
      if (!window.location.pathname.includes("/dashboard/subscription")) {
        window.dispatchEvent(new CustomEvent("plan-upsell", { detail: d }));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return `${API}/files/${data.path}`;
}
